/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M8 7V5.2C8 4.0799 8 3.51984 8.21799 3.09202C8.40973 2.71569 8.71569 2.40973 9.09202 2.21799C9.51984 2 10.0799 2 11.2 2H12.8C13.9201 2 14.4802 2 14.908 2.21799C15.2843 2.40973 15.5903 2.71569 15.782 3.09202C16 3.51984 16 4.07989 16 5.2V7M12 13V15"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<rect
				x="4"
				y="6"
				width="16"
				height="16"
				rx="8"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<rect
				opacity="0.12"
				x="4"
				y="6"
				width="16"
				height="16"
				rx="8"
				fill="currentColor"
			/>
			<path
				d="M8 7V5.2C8 4.0799 8 3.51984 8.21799 3.09202C8.40973 2.71569 8.71569 2.40973 9.09202 2.21799C9.51984 2 10.0799 2 11.2 2H12.8C13.9201 2 14.4802 2 14.908 2.21799C15.2843 2.40973 15.5903 2.71569 15.782 3.09202C16 3.51984 16 4.07989 16 5.2V7M12 13V15M12 22V22C16.4183 22 20 18.4183 20 14V14C20 9.58172 16.4183 6 12 6V6C7.58172 6 4 9.58172 4 14V14C4 18.4183 7.58172 22 12 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M11.2 1.25H11.1696H11.1695C10.6354 1.24999 10.1896 1.24998 9.82533 1.27974C9.44545 1.31078 9.08879 1.37789 8.75153 1.54973C8.23408 1.81339 7.81338 2.23408 7.54973 2.75153C7.37789 3.08879 7.31078 3.44545 7.27974 3.82533C7.24998 4.18956 7.24999 4.63541 7.25 5.16956V5.16957L7.25 5.2V6.65029C4.84281 8.20922 3.25 10.9186 3.25 14C3.25 18.8325 7.16751 22.75 12 22.75C16.8325 22.75 20.75 18.8325 20.75 14C20.75 10.9186 19.1572 8.20922 16.75 6.65029V5.2V5.16955V5.16951C16.75 4.63538 16.75 4.18955 16.7203 3.82533C16.6892 3.44545 16.6221 3.08879 16.4503 2.75153C16.1866 2.23408 15.7659 1.81339 15.2485 1.54973C14.9112 1.37789 14.5546 1.31078 14.1747 1.27974C13.8104 1.24998 13.3646 1.24999 12.8305 1.25H12.8304H12.8H11.2ZM15.25 5.87346V5.2C15.25 4.62757 15.2494 4.24336 15.2252 3.94748C15.2018 3.66036 15.1599 3.52307 15.1138 3.43251C14.9939 3.19731 14.8027 3.00609 14.5675 2.88624C14.4769 2.8401 14.3396 2.79822 14.0525 2.77476C13.7566 2.75059 13.3724 2.75 12.8 2.75H11.2C10.6276 2.75 10.2434 2.75059 9.94748 2.77476C9.66035 2.79822 9.52307 2.8401 9.43251 2.88624C9.19731 3.00609 9.00608 3.19731 8.88624 3.43251C8.8401 3.52307 8.79822 3.66036 8.77476 3.94748C8.75058 4.24336 8.75 4.62757 8.75 5.2V5.87346C9.75479 5.47125 10.8516 5.25 12 5.25C13.1484 5.25 14.2452 5.47125 15.25 5.87346ZM11.25 12.75C11.25 12.3358 11.5858 12 12 12C12.4142 12 12.75 12.3358 12.75 12.75V15.25C12.75 15.6642 12.4142 16 12 16C11.5858 16 11.25 15.6642 11.25 15.25V12.75Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M4.25204 16C4.08751 15.3608 4 14.6906 4 14C4 9.58172 7.58172 6 12 6C16.4183 6 20 9.58172 20 14C20 18.4183 16.4183 22 12 22C9.97111 22 8.11862 21.2447 6.70835 20M8 7V5.2C8 4.0799 8 3.51984 8.21799 3.09202C8.40973 2.71569 8.71569 2.40973 9.09202 2.21799C9.51984 2 10.0799 2 11.2 2H12.8C13.9201 2 14.4802 2 14.908 2.21799C15.2843 2.40973 15.5903 2.71569 15.782 3.09202C16 3.51984 16 4.07989 16 5.2V7M12 13V15"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M8 7V5.2C8 4.0799 8 3.51984 8.21799 3.09202C8.40973 2.71569 8.71569 2.40973 9.09202 2.21799C9.51984 2 10.0799 2 11.2 2H12.8C13.9201 2 14.4802 2 14.908 2.21799C15.2843 2.40973 15.5903 2.71569 15.782 3.09202C16 3.51984 16 4.07989 16 5.2V7M12 13V15M12 22V22C16.4183 22 20 18.4183 20 14V14C20 9.58172 16.4183 6 12 6V6C7.58172 6 4 9.58172 4 14V14C4 18.4183 7.58172 22 12 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.25 14C3.25 9.16751 7.16751 5.25 12 5.25C16.8325 5.25 20.75 9.16751 20.75 14C20.75 18.8325 16.8325 22.75 12 22.75C7.16751 22.75 3.25 18.8325 3.25 14Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M11.1696 1.25L11.2 1.25H12.8L12.8304 1.25C13.3646 1.24999 13.8104 1.24998 14.1747 1.27974C14.5546 1.31078 14.9112 1.37789 15.2485 1.54973C15.7659 1.81338 16.1866 2.23408 16.4503 2.75153C16.6221 3.08879 16.6892 3.44545 16.7203 3.82533C16.75 4.18956 16.75 4.6354 16.75 5.16955V5.2V7C16.75 7.41421 16.4142 7.75 16 7.75C15.5858 7.75 15.25 7.41421 15.25 7V5.2C15.25 4.62757 15.2494 4.24336 15.2252 3.94748C15.2018 3.66036 15.1599 3.52307 15.1138 3.43251C14.9939 3.19731 14.8027 3.00608 14.5675 2.88624C14.4769 2.8401 14.3396 2.79822 14.0525 2.77476C13.7566 2.75058 13.3724 2.75 12.8 2.75H11.2C10.6276 2.75 10.2434 2.75058 9.94748 2.77476C9.66036 2.79822 9.52307 2.8401 9.43251 2.88624C9.19731 3.00608 9.00608 3.19731 8.88624 3.43251C8.8401 3.52307 8.79822 3.66036 8.77476 3.94748C8.75058 4.24336 8.75 4.62757 8.75 5.2V7C8.75 7.41421 8.41421 7.75 8 7.75C7.58579 7.75 7.25 7.41421 7.25 7V5.2L7.25 5.16957C7.24999 4.63541 7.24998 4.18956 7.27974 3.82533C7.31078 3.44545 7.37789 3.08879 7.54973 2.75153C7.81338 2.23408 8.23408 1.81338 8.75153 1.54973C9.08879 1.37789 9.44545 1.31078 9.82533 1.27974C10.1896 1.24998 10.6354 1.24999 11.1696 1.25ZM12 12.25C12.4142 12.25 12.75 12.5858 12.75 13V15C12.75 15.4142 12.4142 15.75 12 15.75C11.5858 15.75 11.25 15.4142 11.25 15V13C11.25 12.5858 11.5858 12.25 12 12.25Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
